import { Component, OnInit, Injectable } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Claimants} from '../../models/claimant';
import { DatePipe } from '@angular/common';

@Component({
 selector: 'app-complete',
 templateUrl: './complete.html',
 styleUrls: ['./complete.css'],
 imports: [DatePipe], // Add this using the DatePipe Directive in the template
})

 @Injectable({
   providedIn: 'root' // Add this line for LocalStorageService
 })

export class Complete implements OnInit {
 claimant: Claimants;

 constructor(
   private storage: LocalStorageService,
 ) { }

 ngOnInit() {
   window.scrollTo(0, 0);
   this.claimant = this.storage.retrieve('claimant');
 }
}
